'use client';

import { useFormatter } from 'next-intl';
import type { LotteryName } from '../../lottery-purchases/types';
import { useLotteryNextDraw } from '../hooks';
import { interpolateMarkup } from './interpolateMarkup';
import { LotteryFaqAccordion } from './LotteryFaqAccordion';

const TIME_FORMAT = { hour: 'numeric', minute: '2-digit', hourCycle: 'h12' } as const;

type FaqItem = {
  question: string;
  answer: string;
};

type LotteryResultsFaqItemsProps = {
  lotteryName: LotteryName;
  items: FaqItem[];
};

function LotteryResultsFaqItems({ lotteryName, items }: LotteryResultsFaqItemsProps) {
  const { data } = useLotteryNextDraw(lotteryName);
  const format = useFormatter();
  const nextDraw = data?.find(draw => draw.lotteryName === lotteryName);
  const dateValues: Record<string, string> = nextDraw
    ? {
        closingDate: format.dateTime(new Date(nextDraw.closingDate.regular), TIME_FORMAT),
        drawingDate: format.dateTime(new Date(nextDraw.drawingDate), TIME_FORMAT),
      }
    : {};

  return <LotteryFaqAccordion items={items.map(item => ({ ...item, answer: interpolateMarkup(item.answer, dateValues) }))} />;
}

export { LotteryResultsFaqItems, type LotteryResultsFaqItemsProps };
